import { createSlice } from "@reduxjs/toolkit";
import { getSubmitYourTestimonialById, updateSubmitYourTestimonialById, deleteSubmitYourTestimonial,createSubmitYourTestimonial,getAllSubmitYourTestimonials } from "../../API/FormsData/SubmitYourTestimonial";

const initialState = {
    getallSubmitYourTestimonials: [],
    loading: false,
    error: null,
    totalPages: 0,
    currentPage: 1,
};

const submitYourTestimonialSlice = createSlice({
  name: "SubmitYourTestimonial",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSubmitYourTestimonialById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSubmitYourTestimonialById.fulfilled, (state, action) => {
        state.loading = false;
        state.getallSubmitYourTestimonials = [action.payload]; // Flat contactUs object array
        state.error = null;
      })
      .addCase(getSubmitYourTestimonialById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateSubmitYourTestimonialById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateSubmitYourTestimonialById.fulfilled, (state, action) => {
        state.loading = false;
        state.updateSubmitYourTestimonial = [action.payload]; // Flat contactUs object array
        state.error = null;
      })
      .addCase(updateSubmitYourTestimonialById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteSubmitYourTestimonial.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteSubmitYourTestimonial.fulfilled, (state, action) => {
        state.loading = false;
        state.deleteSubmitYourTestimonial = [action.payload]; // Flat contactUs object array
        state.error = null;
      })
      .addCase(deleteSubmitYourTestimonial.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getAllSubmitYourTestimonials.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllSubmitYourTestimonials.fulfilled, (state, action) => {
        state.loading = false;
        state.getallSubmitYourTestimonials = action.payload.data;
        state.totalPages = action.payload.totalPages;
        state.currentPage = action.payload.page;
      })
      .addCase(getAllSubmitYourTestimonials.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(createSubmitYourTestimonial.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createSubmitYourTestimonial.fulfilled, (state, action) => {
        state.loading = false;
        state.createSubmitYourTestimonial = [action.payload]; // Flat contactUs object array
        state.error = null;
      })
      .addCase(createSubmitYourTestimonial.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default submitYourTestimonialSlice.reducer;